import { createAction } from '@reduxjs/toolkit';

export type E2eLoginPayload = {
  email: string;
  token: string;
  transactionId: string;
};

export const e2eLogin = createAction<E2eLoginPayload>('e2e/login');
